import { useTranslation } from 'react-i18next';

const PrivateTravelBookingsHeader = () => {
	const { t} = useTranslation();

	return (
		<div className='private-travel-bookings-component'>
			<div className='private-travel-bookings-component__container'>
				<div className='private-travel-bookings-component__title'>{ t('PrivateTravel.Title') }</div>
				<div className='private-travel-bookings-component__description'>{ t('PrivateTravel.Description') }</div>
			</div>
		</div>
	);
};

export default PrivateTravelBookingsHeader;
